module.exports = __webpack_public_path__ + "static/media/wario_0.327e2879.png";